const DEFAULT_BLOCKED_SCHEDULE = {
  days: [0, 1, 2, 3, 4, 5, 6],
  start: '10:00',
  end: '21:00',
};

export const WEEK_DAYS = [
  { value: 0, label: 'Dom' },
  { value: 1, label: 'Seg' },
  { value: 2, label: 'Ter' },
  { value: 3, label: 'Qua' },
  { value: 4, label: 'Qui' },
  { value: 5, label: 'Sex' },
  { value: 6, label: 'Sáb' },
];

export const createDefaultBlockedSchedule = () => ({
  ...DEFAULT_BLOCKED_SCHEDULE,
  days: [...DEFAULT_BLOCKED_SCHEDULE.days],
});

export const normalizeBlockedSchedules = (blockedSchedules) => {
  if (!Array.isArray(blockedSchedules) || blockedSchedules.length === 0) {
    return [createDefaultBlockedSchedule()];
  }

  return blockedSchedules.map((schedule) => ({
    days: Array.isArray(schedule.days) && schedule.days.length
      ? schedule.days.map(Number)
      : [...DEFAULT_BLOCKED_SCHEDULE.days],
    start: schedule.start || DEFAULT_BLOCKED_SCHEDULE.start,
    end: schedule.end || DEFAULT_BLOCKED_SCHEDULE.end,
  }));
};

const timeToMinutes = (time) => {
  if (!time || typeof time !== 'string') return null;

  const [hours, minutes] = time.split(':').map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

  return (hours * 60) + minutes;
};

const isTimeInsideRange = (current, start, end) => {
  if (start <= end) return current >= start && current <= end;

  return current >= start || current <= end;
};

export const isCategoryBlockedBySchedule = (category, date = new Date()) => {
  if (!category?.scheduleEnabled) return false;

  const schedules = normalizeBlockedSchedules(category.blockedSchedules);
  const currentDay = date.getDay();
  const currentTime = (date.getHours() * 60) + date.getMinutes();

  return schedules.some((schedule) => {
    if (!schedule.days.includes(currentDay)) return false;

    const start = timeToMinutes(schedule.start);
    const end = timeToMinutes(schedule.end);
    if (start === null || end === null) return false;

    return isTimeInsideRange(currentTime, start, end);
  });
};

export const isCategoryAvailable = (category, date = new Date()) => {
  if (!category?.active) return false;

  return !isCategoryBlockedBySchedule(category, date);
};

export const getCategoryAvailabilityStatus = (category, date = new Date()) => {
  if (!category?.active) {
    return {
      available: false,
      color: 'danger',
      label: 'Inativa',
    };
  }

  if (isCategoryBlockedBySchedule(category, date)) {
    return {
      available: false,
      color: 'warning',
      label: 'Bloqueada agora',
    };
  }

  return {
    available: true,
    color: 'success',
    label: 'Disponível',
  };
};

export const getCategoryScheduleDescription = (category) => {
  if (!category?.scheduleEnabled) return 'Nenhum — sempre visível';

  return normalizeBlockedSchedules(category.blockedSchedules)
    .map((schedule) => {
      const days = schedule.days
        .map((day) => WEEK_DAYS.find((item) => item.value === day)?.label)
        .filter(Boolean)
        .join(', ');

      return `${days || 'Sem dias'}, das ${schedule.start} às ${schedule.end}`;
    })
    .join(' | ');
};
